import React from 'react';
import { Text, Stack, ControlLink } from '@moda/om';
import { hrefFor } from '../../../../routers';

interface Props {
  shippingStatus: string | { reason: string; request_number: string; return_method: string } | null;
}

export const OrderDetailsShippingStatus: React.FC<Props> = ({ shippingStatus }) => {
  if (typeof shippingStatus === 'string') {
    return (
      <Stack justifyContent="center" space={2}>
        <Text treatment="body2" color="cement">
          Status
        </Text>
        <Text>{shippingStatus}</Text>
      </Stack>
    );
  }

  if (shippingStatus?.reason) {
    return (
      <Stack space={4}>
        <Stack space={1}>
          <Text treatment="body2" color="cement">
            Reason:
          </Text>

          <Text>{shippingStatus.reason}</Text>
        </Stack>

        <Stack space={1}>
          <Text treatment="body2" color="cement">
            Refund To:
          </Text>

          <Text> {shippingStatus.return_method}</Text>
        </Stack>

        <Stack alignItems="flex-start" space={1}>
          <Text treatment="body2" color="cement">
            Request Number:
          </Text>

          <ControlLink
            to={hrefFor.ReturnSummaryPage({
              shipmentNumber: shippingStatus.request_number
            })}
          >
            #{shippingStatus.request_number}
          </ControlLink>
        </Stack>
      </Stack>
    );
  }

  return null;
};
